// extracted by mini-css-extract-plugin
export var borderRadius = "_b2-4";
export var large = "_b2-3";
export var logoContainer = "_b2-0";
export var nameLogo = "_b2-2";
export var small = "_b2-1";